/**
 * Single source of truth for product branding shown in the UI
 * (page titles, footers, version tags, SEO fallbacks).
 */
export const APP_NAME = 'SHIFTCLOCK AI';
export const APP_TAGLINE = 'Employee Time & Attendance Management';
export const APP_VERSION = '1.2026.09.03';
export const APP_WEBSITE_URL = 'https://shiftclockai.com/';
/** The main application, where customers sign in with company code + email + password. */
export const APP_LOGIN_URL = 'https://app.shiftclockai.com/';
export const APP_TERMS_URL = 'https://shiftclockai.com/terms.html';
export const APP_PRIVACY_URL = 'https://shiftclockai.com/privacy.html';

export const COPYRIGHT_TEXT = `© ${new Date().getFullYear()} ${APP_NAME}. All rights reserved.`;
